import { useTranslation } from 'react-i18next';

import { useStaffAuth } from '@/features/auth/useStaffAuth';
import { Login } from '@/routes/Login';

/**
 * The authentication gate.
 *
 * Renders the login screen IN PLACE rather than redirecting: there is one
 * protected area and no deep links into it yet, so a redirect would add a URL
 * to reason about for no gain. When there are routes worth returning to, this
 * becomes a redirect that remembers where you were.
 *
 * The `loading` state is a real state, not a flash of the login form. Rendering
 * the form while the refresh cookie is still being exchanged would show "sign
 * in" to someone who is already signed in — the screen contradicting itself for
 * a few hundred milliseconds on every reload.
 */
export function RequireStaff({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const { state } = useStaffAuth();

  if (state.status === 'loading') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-raad-bg text-raad-muted">
        <span role="status">{t('shell.loading')}</span>
      </div>
    );
  }
  if (state.status === 'anonymous') return <Login />;
  return <>{children}</>;
}
